import Funnel from "../services/funnel-service.js";
import Utils from "../services/utils-service.js";
import Mixin from "../mixin.js";

const template = `
    <div class="grid">
        <div class="s12 m10 l8 clm card center">
        	<br>
            <h2 class="text-center" v-html="input.title"></h2>
            <p v-html="input.text" :class="input.class"></p>
            <div v-if="input.back_url" class="">
               <button :aria-label="input.button_text" class="button medium action fill primary-btn next-step" @click="back()">
                    {{ input.button_text }}
                    <img alt="Arrow icon" class="iconic iconic-sm" data-state="up" data-src="/static/images/iconic/arrow.svg">
                </button>
            </div>
        </div>
    </div>
`;
export default {
    name: 'b-error-page',
    template,
    props: ['iuid'],
    mixins: [Mixin],
    computed: {
        ...Vuex.mapGetters([
            'funnel'
        ]),
        fs: function () {
            return new Funnel({ ctx: this.$store, router: this.$router });
        },
        input: function () {
            return this.$store.getters.funnel.elements[this.iuid];
        }
    },
    methods: {
        back() {
            if (!Utils.isEmpty(this.input.back_url)) {
                this.fs.internalErrorRedirectHandler(this);
            } else {
                this.$router.back();
            }
        }
    }
};
